// Excel (.xlsx) export of Manufacturing Orders — one order (MO page) or the list.
import { downloadExcel } from './excel';
import { buildImageUrl } from './imageUrl';

const STATUS = { draft: 'Draft', submitted: 'Pending Approval', approved: 'Approved', rejected: 'Rejected' };

const fmtDate = (v) => {
  if (!v) return '';
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};
const yes = (on, qty) => (on ? (qty !== null && qty !== undefined && qty !== '' ? `Yes (${Number(qty)})` : 'Yes') : '');
const size = (it) => [it.size_length, it.size_width, it.size_thickness].filter(Boolean).join(' x ') || it.product_size || '';
const safe = (s) => String(s || 'Manufacturing-Order').replace(/[\\/:*?"<>|]+/g, '-').trim();

// One spreadsheet row per order item
function itemRow(it, i, extra = {}) {
  const imageCount = it.images ? it.images.length : Number(it.image_count || 0);
  const firstImage = it.images?.[0]?.image_path || it.first_image || '';
  return {
    ...extra,
    'S.No': it.s_no || i + 1,
    Area: it.area || '',
    'Proto Code': it.proto_code || '',
    'Product Name': it.product_name || '',
    'Size (L x W x T)': size(it),
    'Finish Notes': it.finishes_note || '',
    'Paint Finish': yes(Number(it.is_paint_finish), it.paint_qty),
    'Fabric Finish': yes(Number(it.is_fabric_finish), it.fabric_qty),
    'Metal Finish': Number(it.is_metal_finish) ? 'Yes' : '',
    Qty: Number(it.qty) || 0,
    Remark: it.remark || '',
    Images: imageCount,
    'First Image': firstImage ? buildImageUrl(firstImage) : '',
    'In Project': it.project_item_id ? 'Yes' : 'No',
  };
}

// MO page: "Order" summary sheet + "Items" sheet
export function exportMoToExcel(po) {
  const items = po.items || [];
  const order = [
    ['Field', 'Value'],
    ['Manufacturing Order No.', po.po_no || ''],
    ['Project Name', po.project_name || ''],
    ['Client', po.client_name || ''],
    ['PMC', po.pmc_name || ''],
    ['Order Date', fmtDate(po.order_date)],
    ['Timelines', po.timelines || ''],
    ['Remarks', po.remarks || ''],
    ['Status', STATUS[po.status] || po.status || ''],
    ['Linked Project', po.linked_project_code || ''],
    ['Proto Code Mode', po.proto_mode === 'auto' ? 'Automatic' : 'Manual'],
    ['Total Items', items.length],
    ['Total Qty', items.reduce((s, it) => s + (Number(it.qty) || 0), 0)],
    ['Created By', po.created_by_name || ''],
    ['Approved By', po.approved_by_name || ''],
  ];
  return downloadExcel(`${safe(po.po_no)}.xlsx`, [
    { name: 'Order', rows: order },
    { name: 'Items', rows: items.map((it, i) => itemRow(it, i)) },
  ]);
}

// MO list: "Orders" sheet + "Items" sheet (items of every listed order)
export function exportMoListToExcel(orders, items, label = 'All') {
  const ordersRows = orders.map((o) => ({
    'MO No.': o.po_no || '',
    'Project Name': o.project_name || '',
    Client: o.client_name || '',
    PMC: o.pmc_name || '',
    'Order Date': fmtDate(o.order_date),
    Timelines: o.timelines || '',
    Items: Number(o.item_count) || 0,
    Status: STATUS[o.status] || o.status || '',
    'Linked Project': o.linked_project_code || '',
    'Created By': o.created_by_name || '',
    'Created On': fmtDate(o.created_at),
  }));
  const itemRows = items.map((it, i) => itemRow(it, i, { 'MO No.': it.po_no || '' }));
  const today = new Date().toISOString().slice(0, 10);
  return downloadExcel(`Manufacturing-Orders-${safe(label)}-${today}.xlsx`, [
    { name: 'Orders', rows: ordersRows },
    { name: 'Items', rows: itemRows },
  ]);
}
